/*
 * @author: Razvan Rauta
 * Date: 06/08/2021
 * Time: 12:16
 */

import React from 'react';
import { ListItemText } from '@mui/material';
import { MenuItem } from '../../MenuItem/MenuItem';
import Checkbox from '../../Checkbox/Checkbox';

function RoleMenuItem({ classes, disabled, checked, role, handleClick, getRoleLabel }) {
  return (
    <MenuItem
      value={role.uuid}
      disabled={disabled}
      onClick={() => handleClick(role.uuid)}
      className={classes.roleMenuItem}
      title={getRoleLabel(role.roleName)}
    >
      <Checkbox style={{ marginLeft: -2 }} checked={checked} />
      <ListItemText
        classes={{
          primary: classes.listItemText,
          root: classes.listItemRoot,
        }}
        primary={getRoleLabel(role.roleName)}
      />
    </MenuItem>
  );
}

export default RoleMenuItem;
